/*
 * A aba "Rascunhos" do perfil (`/u/:username/drafts`),
 * com os rascunhos do fof/drafts: só a própria pessoa a vê. Cada rascunho
 * mostra o tipo (tópico novo, resposta, mensagem), o título, o começo do
 * texto e há quanto tempo foi mexido, com "Continuar" e "Excluir".
 */
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import { truncate } from 'flarum/common/utils/string';
import { allDrafts, deleteDraft, draftIcon, draftsOn, draftTitle, ensureDiscussions, fofState, loadDrafts, openDraft } from './fofDrafts';
import { fullDate, shortAge } from '../../../utils/dates';
import { t } from '../../../utils/settings';
const TYPE_KEYS = {
  discussion: 'type_new_topic',
  reply: 'type_reply',
  privateDiscussion: 'type_message'
};
export default class DraftsUserPage extends UserPage {
  loading = true;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    // Rascunhos são de quem escreveu: no perfil de outra pessoa a aba não
    // existe, e a URL digitada à mão leva às postagens dela.
    if (user !== app.session.user || !draftsOn()) {
      m.route.set(app.route('user.posts', {
        username: user.slug()
      }), undefined, {
        replace: true
      });
      return;
    }
    super.show(user);
    loadDrafts().then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) return m(LoadingIndicator, null);
    const drafts = allDrafts();
    const state = fofState();
    if (!drafts.length) return m(Placeholder, {
      text: t('composer.drafts.empty')
    });
    ensureDiscussions(drafts);
    return m("div", {
      className: "CanelaDrafts"
    }, m("ul", {
      className: "CanelaDrafts-list"
    }, drafts.map(draft => this.item(draft))), state?.hasNextPage && m("div", {
      className: "CanelaDrafts-more"
    }, m(Button, {
      className: "Button",
      loading: state.loadingMore,
      onclick: () => state.loadMore()
    }, t('composer.drafts.load_more'))));
  }
  item(draft) {
    const type = draft.type();
    const updated = draft.updatedAt();
    const text = (draft.content() || '').replace(/\s+/g, ' ').trim();
    return m("li", {
      key: draft.id(),
      className: `CanelaDrafts-item CanelaDrafts-item--${type}`
    }, m("span", {
      className: "CanelaDrafts-icon",
      "aria-hidden": "true"
    }, m(Icon, {
      name: draftIcon(draft)
    })), m("div", {
      className: "CanelaDrafts-main"
    }, m("div", {
      className: "CanelaDrafts-context"
    }, t(`composer.drafts.${TYPE_KEYS[type] || 'type_new_topic'}`), updated && m("time", {
      className: "CanelaDrafts-time",
      dateTime: updated.toISOString(),
      title: fullDate(updated)
    }, ' · ', shortAge(updated))), m("h3", {
      className: "CanelaDrafts-title"
    }, draftTitle(draft)), text && m("p", {
      className: "CanelaDrafts-excerpt"
    }, truncate(text, 200))), m("div", {
      className: "CanelaDrafts-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-pen",
      onclick: () => openDraft(draft)
    }, t('composer.drafts.resume')), m(Button, {
      className: "Button Button--icon CanelaDrafts-delete",
      icon: "far fa-trash-can",
      "aria-label": t('composer.drafts.delete'),
      title: t('composer.drafts.delete'),
      onclick: () => deleteDraft(draft)
    })));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/composer/drafts/DraftsUserPage', DraftsUserPage);